import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import API from '../api/axios';
import { useAuth } from '../context/AuthContext';

export default function GoogleAuthButton({ label = 'Continue with Google' }) {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      setLoading(true);
      setError('');
      try {
        const res = await API.post('/api/auth/google', {
          access_token: tokenResponse.access_token,
        });
        const { user, token, refresh_token } = res.data;
        login(user, token, refresh_token);

        try {
          await API.get('/api/profile/me');
          navigate('/swipe');
        } catch {
          navigate('/profile-setup');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Google sign-in failed. Try again.');
      } finally {
        setLoading(false);
      }
    },
    onError: () => {
      setError('Google sign-in was cancelled or failed.');
    },
  });

  return (
    <div>
      <button
        onClick={() => handleGoogleLogin()}
        disabled={loading}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          width: '100%',
          padding: '12px',
          border: '1px solid #ddd',
          borderRadius: '8px',
          background: 'white',
          color: '#333',
          fontSize: '15px',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1,
          marginTop: '12px',
        }}
      >
        <img
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
          alt="Google"
          style={{ width: '20px', height: '20px' }}
        />
        {loading ? 'Signing in...' : label}
      </button>
      {error && (
        <p style={{ color: 'red', fontSize: '13px', marginTop: '8px', textAlign: 'center' }}>
          {error}
        </p>
      )}
    </div>
  );
}